<template>
    <div>
        <div class="d-flex justify-space-between align-center" v-if="!$store.state.baseLoading">
            <v-btn icon="mdi-arrow-right" variant="text" @click="$store.commit('setActivePage',backPage)"></v-btn>
            <h3>{{ $store.state.info.direct_title }}</h3>

            <v-btn v-if="$store.getters.getAuthToken == ''" 
                    :disabled="$store.state.baseLoading"
                    variant="outlined" 
                    @click="$store.commit('setLoginDialogStatus', true)">
                {{ $t('booking.login_button') }}
            </v-btn>
            
            <v-menu v-else>
                <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" icon="mdi-account" variant="text"></v-btn>
                </template>
                <v-list class="text-center">
                    <v-list-item>
                        {{ $t('booking.welcome_message', { mobile: $store.state.mobile }) }}
                    </v-list-item>
                    <v-list-item
                    @click="$store.commit('setActivePage', 'orders_history');">
                        لیست سفارشات
                    </v-list-item>
                    <v-list-item @click="$store.dispatch('logout')" class="text-red">
                        {{ $t('booking.logout_button') }}
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
        <v-progress-linear v-else indeterminate color="white" class="my-6"></v-progress-linear>


        <v-fab @click="open=!open" v-if="$store.state.info.active" app location="left bottom" icon size="x-large" elevation="10" :style="$store.state.cart.length > 0 && $store.state.activePage == 'booking'?'height: calc(100% + -58px) !important;':''">
            <img src="https://limoapp.ir/img/waiter.png" height="55"/>

            <v-speed-dial v-model="open" location="top center" transition="scale-transition" activator="parent">
                <v-btn size="large" elevation="10" class="d-flex justify-space-between" key="1" color="error" @click="$store.dispatch('callWaiter',true)">
                    <v-icon size="21">mdi-room-service</v-icon>
                    فراخوان گارسون
                </v-btn>
                <v-btn elevation="10"  class="d-flex justify-space-between" key="2" color="info" @click="joinTelegramBotDialogStatus=!joinTelegramBotDialogStatus">
                    <v-icon size="21">mdi-send-circle</v-icon>
                    اتصال به تلگرام
                </v-btn>
                <v-btn elevation="10"  class="d-flex justify-space-between" key="3" color="success" @click="joinBaleBotDialogStatus=!joinBaleBotDialogStatus">
                    <v-icon size="21">mdi-check-circle</v-icon>
                    اتصال به بله
                </v-btn>
            </v-speed-dial>

        </v-fab>
        <v-dialog
            v-model="$store.state.callWaiterDialogStatus"
            v-if="$store.state.callWaiterDialogStatus"
            scrollable  
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
        >
            <v-card>
                <v-card-actions>
                    <h4>فراخوان گارسون</h4>
                    <v-spacer></v-spacer>
                    <v-btn color="error" icon="mdi-close" variant="text" @click="$store.dispatch('callWaiter',false)"/>
                </v-card-actions>
                <v-card-text>
                    <v-text-field
                        density="compact"
                        dir="ltr"
                        class="text-center"
                        v-model="$store.state.table_number"
                        :readonly="!$store.state.table_number_editable"
                        variant="outlined"
                        label="شماره میز"
                        />
                    <v-textarea
                        density="compact"
                        v-model="$store.state.request_description"
                        variant="outlined"
                        rows="2"
                        label="شرح درخواست(اختیاری)"
                        />

                    <v-btn
                        block
                        color="primary"
                        variant="flat"
                        :loading="$store.state.bookingLoading"
                        @click="$store.dispatch('SubmitCallWaiter',{
                            table_number:$store.state.table_number,
                            request_description:$store.state.request_description,
                        })"
                        >
                        ارسال فراخوان
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="joinTelegramBotDialogStatus"
            v-if="joinTelegramBotDialogStatus"
            scrollable  
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
        >
            <v-card>
                <v-card-actions>
                    <h4>اتصال به تلگرام</h4>
                    <v-spacer></v-spacer>
                    <v-btn color="error" icon="mdi-close" variant="text" @click="joinTelegramBotDialogStatus=!joinTelegramBotDialogStatus"/>
                </v-card-actions>
                <v-divider/>
                <v-card-text class="text-justify">
                    <p>
                        با استارت کردن ربات تلگرام مجموعه، می‌توانید اطلاع رسانی وضعیت سفارش‌های خود را از طریق ربات تلگرام دریافت نمایید.
                    </p>
                    <v-img class="my-2" src="https://limoapp.ir/img/limoappbot.webp" />
                    <p>
                        برای اتصال مطابق تصویر ،پس از کلیک روی لینک زیر و استارت ربات، روی دکمه "اشتراک شماره موبایل" کلیک کنید.
                    </p>
                    <div class="text-center mt-5">
                        <v-btn color="primary" @click="openTelegramBot" block elevation="12">
                            باز کردن ربات در تلگرام
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="joinBaleBotDialogStatus"
            v-if="joinBaleBotDialogStatus"
            scrollable  
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
        >
            <v-card>
                <v-card-actions>
                    <h4>اتصال به بله</h4>
                    <v-spacer></v-spacer>
                    <v-btn color="error" icon="mdi-close" variant="text" @click="joinBaleBotDialogStatus=!joinBaleBotDialogStatus"/>
                </v-card-actions>
                <v-divider/>
                <v-card-text class="text-justify">
                    <p>
                        با استارت کردن ربات بله مجموعه، می‌توانید اطلاع رسانی وضعیت سفارش‌های خود را از طریق ربات بله دریافت نمایید.
                    </p>
                    <v-img class="my-2" src="https://limoapp.ir/img/limoappbot.webp" />
                    <p>
                        برای اتصال مطابق تصویر ،پس از کلیک روی لینک زیر و استارت ربات، روی دکمه "اشتراک شماره موبایل" کلیک کنید.
                    </p>
                    <div class="text-center mt-5">
                        <v-btn color="success" @click="openBaleBot" block elevation="12">
                            باز کردن ربات در بله
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props:{
        backPage:{
            type:String,
            default:"splash",
            required:true
        }
    },
    data(){
        return{
            open:false,
            joinTelegramBotDialogStatus:false,
            joinBaleBotDialogStatus:false,
        }
    },
    methods: {
        openTelegramBot() {
            const botUsername = "limoappbot";
            const appLink = `tg://resolve?domain=${botUsername}`;
            const webLink = `https://t.me/${botUsername}`;
            const now = Date.now();
            // برای iOS و برخی مرورگرها باید مستقیم URL رو ست کنیم
            window.location.href = appLink;

            // اگر اپ باز بشه، صفحه فعلی تغییر می‌کنه و تایمر اجرا نمی‌شه
            // اگر بعد از 1 ثانیه هنوز تو صفحه هست، مرورگر باز می‌کنیم
            setTimeout(() => {
                const timeDiff = Date.now() - now;

                // فقط اگه کمتر از 1200ms گذشته باشه یعنی اپ باز نشده
                if (timeDiff < 1200) {
                // باز کردن ربات در تب جدید مرورگر
                window.open(webLink, "_blank");
                }
            }, 1000);
        },
        openBaleBot() {
            const botUsername = "limoappbot";
            const webLink = `https://ble.ir/${botUsername}`;
            window.open(webLink, "_blank");
        }
    },
}
</script>